export default {
  'dishPreference.title': 'Preference Category',
  'dishPreference.field.name': 'Category Name',
  'dishPreference.field.foreign_name': 'Foreign Name',
  'dishPreference.field.option.index': 'Option {index}',
  'dishPreference.field.option.name': 'Name',
  'dishPreference.field.option.foreign_name': 'Foreign Name(optional)',
  'dishPreference.field.option.price': 'Default Price(optinal)',
  'dishPreference.action.delete': 'Delete This Category',
  'dishPreference.action.addMore': 'Add more options',
  'dishPreference.action.addOptions': 'Add Options',
  'dishPreference.name.isRequired': 'name is required',
  'dishPreference.foreign_name.isRequired': 'foreign name is required',
  'dishPreference.name.existed': 'name is occupied',
  'dishPreference.foreign_name.existed': 'foreign name is occupied',
  'dishPreference.option.name.isRequired': 'option name is required',
  'dishPreference.option.name.existed': 'option name is existed',
  'dishPreference.option.foreign_name.existed': 'option foreign name is existed',
  'dishPreference.option.isApplied':
    'This option is attached to customized option(s), you should disconect them before deleting.',
  'dishPreference.category.isApplied':
    'This category is attached to customized option(s), you should disconect them before deleting.',
  'dishPreference.deletion.promptTitle': 'Deletion Prompt',
  'dishPreference.deletion.promptContent': 'Sure to delete this dish preference category?',
};
